import { render, staticRenderFns } from "./ChartInvestmentInfoGroup.vue?vue&type=template&id=9b8fe8ce&scoped=true"
import script from "./ChartInvestmentInfoGroup.vue?vue&type=script&lang=js"
export * from "./ChartInvestmentInfoGroup.vue?vue&type=script&lang=js"
import style0 from "./ChartInvestmentInfoGroup.vue?vue&type=style&index=0&id=9b8fe8ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8fe8ce",
  null
  
)

export default component.exports